export default "__VITE_ASSET__Bqthd_Bj__"